(() => {
  const ROOT = '.amr-cr[data-section-id]';

  function getColumns(section) {
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    const raw = mobile
      ? parseFloat(section.getAttribute('data-columns-mobile') || '1')
      : parseInt(section.getAttribute('data-columns') || '3', 10);
    return Number.isFinite(raw) && raw > 0 ? raw : 1;
  }

  function layoutSlides(viewport, track, slides, gap) {
    const columns = getColumns(viewport.closest(ROOT));
    const viewportW = viewport.clientWidth;
    if (!viewportW || !slides.length) return;

    const slideW = (viewportW - gap * (columns - 1)) / columns;

    slides.forEach((slide) => {
      slide.style.flex = `0 0 ${slideW}px`;
      slide.style.width = `${slideW}px`;
      slide.style.maxWidth = `${slideW}px`;
    });

    track.style.gap = `${gap}px`;
  }

  function initSection(section) {
    if (!section || section.__amrCrInit) return;
    section.__amrCrInit = true;

    const viewport = section.querySelector('[data-amr-cr-viewport]');
    const track = section.querySelector('[data-amr-cr-track]');
    const dotsWrap = section.querySelector('[data-amr-cr-dots]');
    const prevBtn = section.querySelector('[data-amr-cr-prev]');
    const nextBtn = section.querySelector('[data-amr-cr-next]');

    if (!viewport || !track) return;

    const slides = Array.from(track.querySelectorAll('[data-amr-cr-slide]'));
    if (!slides.length) return;

    const gap = parseInt(getComputedStyle(section).getPropertyValue('--amr-cr-gap'), 10) || 24;
    const autoplay = section.getAttribute('data-autoplay') === 'true';
    const interval = Math.max(2000, parseInt(section.getAttribute('data-interval') || '4000', 10) || 4000);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    let timer = null;
    let columns = getColumns(section);
    let maxIndex = 0;

    function updateBounds() {
      columns = getColumns(section);
      maxIndex = Math.max(0, slides.length - Math.ceil(columns));
      if (index > maxIndex) index = maxIndex;
    }

    function setTransform() {
      const slide = slides[0];
      if (!slide) return;

      const slideW = slide.offsetWidth;
      const offset = index * (slideW + gap);
      track.style.transform = `translate3d(-${offset}px, 0, 0)`;

      slides.forEach((s, i) => {
        const isActive = i >= index && i < index + Math.ceil(columns);
        s.classList.toggle('is-active', isActive);
      });

      if (dotsWrap) {
        dotsWrap.querySelectorAll('.amr-cr__dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
    }

    function goTo(i) {
      updateBounds();
      index = Math.min(Math.max(i, 0), maxIndex);
      setTransform();
    }

    function measure() {
      layoutSlides(viewport, track, slides, gap);
      updateBounds();
      setTransform();
    }

    function buildDots() {
      if (!dotsWrap || slides.length < 2) return;

      dotsWrap.innerHTML = '';
      updateBounds();

      for (let i = 0; i <= maxIndex; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'amr-cr__dot';
        dot.setAttribute('aria-label', `Go to review slide ${i + 1}`);
        dot.addEventListener('click', () => {
          goTo(i);
          restart();
        });
        dotsWrap.appendChild(dot);
      }
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || slides.length <= Math.ceil(columns) || reduceMotion) return;
      stop();
      timer = window.setInterval(() => {
        goTo(index >= maxIndex ? 0 : index + 1);
      }, interval);
    }

    function restart() {
      stop();
      start();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goTo(index <= 0 ? maxIndex : index - 1);
        restart();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goTo(index >= maxIndex ? 0 : index + 1);
        restart();
      });
    }

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        buildDots();
        measure();
      }, 120);
    });

    buildDots();
    measure();

    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (evt) => {
    if (evt.target) boot(evt.target);
  });
})();
